import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      title: 'The Ultimate Guide to Hi-Fi Audio Systems',
      excerpt: 'Discover how to choose the perfect high-fidelity audio system for your home and experience music like never before.',
      image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=600&h=400&fit=crop&q=80',
      date: 'January 15, 2025',
      category: 'Hi-Fi Audio'
    },
    {
      title: 'Creating the Perfect Home Theater Experience',
      excerpt: 'Learn the essential elements of designing a home theater that rivals commercial cinemas.',
      image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=600&h=400&fit=crop&q=80',
      date: 'January 10, 2025',
      category: 'Home Theater'
    },
    {
      title: 'Smart Home Automation: The Future is Now',
      excerpt: 'Explore how home automation can transform your living space into an intelligent, responsive environment.',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop&q=80',
      date: 'January 5, 2025',
      category: 'Automation'
    },
    {
      title: 'Understanding Audio Calibration and Room Acoustics',
      excerpt: 'Why professional calibration is essential for optimal sound quality in your listening space.',
      image: 'https://images.unsplash.com/photo-1545454660-877a4a8c4a9e?w=600&h=400&fit=crop&q=80',
      date: 'December 28, 2024',
      category: 'Hi-Fi Audio'
    },
    {
      title: 'Top Premium Audio Brands for 2025',
      excerpt: 'A comprehensive look at the leading audio brands delivering exceptional performance.',
      image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=400&fit=crop&q=80',
      date: 'December 20, 2024',
      category: 'Brands'
    },
    {
      title: 'Lighting Control: Enhancing Your Home Ambiance',
      excerpt: 'How smart lighting systems can create the perfect atmosphere for any occasion.',
      image: 'https://images.unsplash.com/photo-1556910110-a5a63dfd393c?w=600&h=400&fit=crop&q=80',
      date: 'December 15, 2024',
      category: 'Automation'
    }
  ];

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="blog-hero-overlay"></div>
        <div className="blog-hero-content">
          <h1>Insights & Expertise</h1>
          <p>Stay updated with the latest trends, tips, and innovations in audio-visual technology</p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-content">
        <div className="container">
          <div className="blog-grid">
            {blogPosts.map((post, index) => (
              <article className="blog-card" key={index}>
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                  <span className="blog-category">{post.category}</span>
                </div>
                <div className="blog-details">
                  <span className="blog-date">{post.date}</span>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <Link to="#" className="read-more">Read More →</Link>
                </div>
              </article>
            ))}
          </div>

          {/* Coming Soon Note */}
          <div className="blog-note">
            <p>More articles coming soon! Subscribe to our newsletter to stay updated.</p>
            <Link to="/contact" className="btn btn-primary">Subscribe</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
